import React from "react";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/MyAddresses.css";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const MyAddresses = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-7">
							<Logout />
							<div className="address-form-wrapper">
								<div className="heading">
									<h5>Addresses</h5>
								</div>
								<div className="form-wrapper">
									<form action="">
										<div className="form-group row">
											<div className="col-lg-6">
												<label htmlFor="">First Name</label>
												<input type="text" className="form-control" />
											</div>
											<div className="col-lg-6">
												<label htmlFor="">Last Name</label>
												<input type="text" className="form-control" />
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-6">
												<label htmlFor="">Phone</label>
												<input type="text" className="form-control" />
											</div>
											<div className="col-lg-6">
												<label htmlFor="">Email</label>
												<input type="text" className="form-control" />
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-6">
												<label htmlFor="">Address</label>
												{/* <input
                          type="text"
                          className="form-control"
                        /> */}
												<textarea
													name=""
													className="form-control"
													id=""
													cols="30"
													rows="5"
												></textarea>
											</div>
											<div className="col-lg-6">
												<label htmlFor="">Suit, Apartment, etc</label>
												{/* <input
                          type="text"
                          className="form-control"
                        /> */}
												<textarea
													name=""
													className="form-control"
													id=""
													cols="30"
													rows="5"
												></textarea>
											</div>
										</div>
										<div className="form-group row">
											<div className="col-lg-3">
												<label htmlFor="">City</label>
												<input type="text" className="form-control" />
											</div>
											<div className="col-lg-3">
												<label htmlFor="">State</label>
												<input type="text" className="form-control" />
											</div>
											<div className="col-lg-3">
												<label htmlFor="">Country/Region</label>
												<input type="text" className="form-control" />
											</div>
											<div className="col-lg-3">
												<label htmlFor="">Zip Code</label>
												<input type="text" className="form-control" />
											</div>
										</div>
										<div className="form-group">
											<button className="btn" type="submit">
												Add Address
											</button>
										</div>
									</form>
								</div>
							</div>
							<div className="save-address">
								<div className="heading">
									<h3>Saved Address</h3>
								</div>
								{/* <!-- Saved Address --> */}
								<label className="container">
									<input type="radio" checked="checked" name="radio" />
									<span className="checkmark">
										<div className="select-address">
											<div className="address-detail">
												<div className="actions">
													<a href="#" className="editAddress edit">
														<i className="fa-regular fa-pen-to-square"></i>
													</a>
													<a href="#">
														<i className="fa-solid fa-trash-can"></i>
													</a>
												</div>
												<h5>
													<span className="property">Country:</span>
													<div className="spacer"></div>
													<span className="value">United States</span>
												</h5>
												<h5>
													<span className="property">Address:</span>
													<div className="spacer"></div>
													<span className="value">
														10515 Fox Ave Fairdale, Kentucky(KY), 40118
													</span>
												</h5>
												<h5>
													<span className="property">Phone:</span>
													<div className="spacer"></div>
													<span className="value">+44-123-456-789</span>
												</h5>
												<h5>
													<span className="property">State:</span>
													<div className="spacer"></div>
													<span className="value">Texas</span>
												</h5>
												<div className="deafult">
													<h5>Use as default</h5>
													<span className="dot"></span>
												</div>
											</div>
										</div>
									</span>
								</label>
								{/* <!-- Saved Address --> */}
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default MyAddresses;
